'use client'

import { useResponsive, useTranslations } from '@dustin-web/microsite-components/src/hooks'
import { Icon } from '@dustin-web/microsite-components/src/icon-library'
import {
  ModalDialog,
  ModalDialogContent,
  ModalDialogFooter,
  ModalDialogHeader,
} from '@dustin-web/microsite-components/src/modal-dialog'
import { useState } from 'react'

type ModalClientProps = {
  children: React.ReactNode
  title?: string | undefined
}

export default function ModalClient({ title, children }: ModalClientProps) {
  const [isOpen, setIsOpen] = useState<boolean>(false)
  const { isSmallScreen } = useResponsive()
  const { translate } = useTranslations()

  return (
    <>
      <span
        className='product-common-charger__info-container--info-text common-charger__info-container--info-text'
        tabIndex={0}
        role="button"
        onClick={() => {
          setIsOpen(true)
        }}
        onKeyDown={e => {
          if (e.key === 'Enter') setIsOpen(true)
        }}
      >
        {title}
      </span>

      <Icon
        aria-label={translate('Common_Charger_Info_AriaLabel')}
        className="product-common-charger__info-container--info-icon common-charger__info-container--info-icon"
        name="info"
        onClick={() => {
          setIsOpen(true)
        }}
        onKeyDown={e => {
          if (e.key === 'Enter') setIsOpen(true)
        }}
        tabIndex={0}
        role="button"
      />

      <ModalDialog
        show={isOpen}
        handleClose={() => setIsOpen(false)}
        size={isSmallScreen ? 'sm' : 'lg'}
        arial-hidden={!isOpen}
        aria-live="assertive">
        <ModalDialogHeader title={title} />
        <ModalDialogContent>{children}</ModalDialogContent>
        <ModalDialogFooter showConfirm closeOnConfirm confirmText={translate('MobileCloseLabel')} />
      </ModalDialog>
    </>
  )
}
